import { SvgIcon } from './svg-icon';
import { ComponentSvgIconProps, SvgIconProps } from './svg-icon.d';
import { mergeProps } from 'solid-js';

const defaultProps: SvgIconProps = {
    viewBox: '0 0 28 28',
    fill: 'currentColor',
    defaultAriaLabel: 'Zoom In Icon',
};

export const ZoomInCviIcon = (componentProps: ComponentSvgIconProps) => {
    const props = mergeProps(defaultProps, componentProps);

    return (
        <SvgIcon {...props}>
            <path d="M13 8.5C13.5523 8.5 14 8.94772 14 9.5V12H16.5C17.0523 12 17.5 12.4477 17.5 13C17.5 13.5523 17.0523 14 16.5 14H14V16.5C14 17.0523 13.5523 17.5 13 17.5C12.4477 17.5 12 17.0523 12 16.5V14H9.5C8.94772 14 8.5 13.5523 8.5 13C8.5 12.4477 8.94772 12 9.5 12H12V9.5C12 8.94772 12.4477 8.5 13 8.5Z" />
            <path fill-rule="evenodd" clip-rule="evenodd" d="M13 2C6.92487 2 2 6.92487 2 13C2 19.0751 6.92487 24 13 24C15.6775 24 18.1316 23.0434 20.0391 21.4533L24.2929 25.7071C24.6834 26.0976 25.3166 26.0976 25.7071 25.7071C26.0976 25.3166 26.0976 24.6834 25.7071 24.2929L21.4533 20.0391C23.0434 18.1316 24 15.6775 24 13C24 6.92487 19.0751 2 13 2ZM4 13C4 8.02944 8.02944 4 13 4C17.9706 4 22 8.02944 22 13C22 17.9706 17.9706 22 13 22C8.02944 22 4 17.9706 4 13Z" />
        </SvgIcon>
    );
};
